module.exports = __webpack_public_path__ + "d58b8baf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instagram/Storytape-12.jpg
// module id = 1276
// module chunks = 1 4